<div class='alert alert-{{level}} {{transition}}' *ngIf="open">
  <ng-content></ng-content>
  <span class="close" (click)="close()">&#43;</span>
</div>